const RaRichTextInput = () => ({
  styleOverrides: {
    root: {
      alignItems: 'flex-start'
    }
  }
});

export default RaRichTextInput;
